'use es6';

import { useCallback, useEffect } from 'react';
import Raven from 'raven-js';
import { setupCes } from 'wootric-nps/ces/ces-setup';

const useWootricSurvey = () => {
  const CES_KEY = 'ACADEMY';
  const triggerSurvey = useCallback(() => {
    try {
      setupCes(CES_KEY);
    } catch (error) {
      Raven.captureException(error, {
        extra: {
          from: 'triggerWootricSurvey'
        }
      });
    }
  }, []);
  useEffect(() => {
    triggerSurvey();
  }, [triggerSurvey]);
};

export default useWootricSurvey;